import { render } from "./TabPlantDetails.vue?vue&type=template&id=5153a7a5&scoped=true"
import script from "./TabPlantDetails.vue?vue&type=script&lang=js"
export * from "./TabPlantDetails.vue?vue&type=script&lang=js"

import "./TabPlantDetails.vue?vue&type=style&index=0&id=5153a7a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5153a7a5"]])

export default __exports__